
import { DiaryEntry } from "@/utils/diary";
import EntryMetadata from "./header/EntryMetadata";
import DateDisplay from "./header/DateDisplay";
import EditButton from "./header/EditButton";
import { useLanguage } from "@/contexts/language";

interface EntryCardHeaderProps {
  entry: DiaryEntry;
  readOnly: boolean;
  onEditClick: () => void;
  onDateEdit?: (newDate: Date) => void;
}

const EntryCardHeader = ({
  entry,
  readOnly,
  onEditClick,
  onDateEdit
}: EntryCardHeaderProps) => {
  const entryDate = new Date(entry.createdAt);
  const { language } = useLanguage();
  
  return (
    <div className="flex justify-between items-start space-y-0">
      <div className="space-y-1.5">
        <div className="flex items-center gap-2">
          <EntryMetadata 
            age={entry.age || ""}
            isPremium={entry.isPremium}
            babyBirthday={entry.babyBirthday}
          />
          
          <DateDisplay
            date={entryDate}
            readOnly={readOnly}
            onDateEdit={onDateEdit}
          />
        </div>
        
        <h3 className="text-xl font-medium">
          {entry.title || `Today with ${entry.babyName}`}
        </h3>
      </div>
      
      {!readOnly && (
        <div className="flex items-center gap-2">
          <EditButton onClick={onEditClick} />
        </div>
      )}
    </div>
  );
};

export default EntryCardHeader;
